interface BlogPaginationProps {
  currentPage: number;
  onPageChange: (page: number) => void;
  totalPosts: number; // total posts available on the server
  postsPerPage?: number; // optional, default 9
}

export default function BlogPagination({
  currentPage,
  onPageChange,
  totalPosts,
  postsPerPage = 9,
}: BlogPaginationProps) {
  const totalPages = Math.ceil(totalPosts / postsPerPage);

  if (totalPosts === 0 || totalPages <= 1) return null; // hide pagination if no posts

  // Optional: limit displayed page numbers to avoid huge lists
  const getPageNumbers = () => {
    const pages = [];
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, currentPage + 2);

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  };

  const handleNext = () => {
    if (currentPage < totalPages) onPageChange(currentPage + 1);
  };

  const handlePrev = () => {
    if (currentPage > 1) onPageChange(currentPage - 1);
  };

  return (
    <div className="flex justify-center items-center space-x-2 mt-12">
      <button
        onClick={handlePrev}
        disabled={currentPage === 1}
        className="px-3 py-2 rounded-lg border border-gray-300 text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
      >
        <i className="ri-arrow-left-line"></i>
      </button>

      {getPageNumbers().map((page) => (
        <button
          key={page}
          onClick={() => onPageChange(page)}
          className={`px-4 py-2 rounded-lg font-medium cursor-pointer ${
            currentPage === page
              ? "bg-blue-600 text-white"
              : "border border-gray-300 text-gray-700 hover:bg-gray-50"
          }`}
        >
          {page}
        </button>
      ))}

      <button
        onClick={handleNext}
        disabled={currentPage === totalPages}
        className="px-3 py-2 rounded-lg border border-gray-300 text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
      >
        <i className="ri-arrow-right-line"></i>
      </button>
    </div>
  );
}
